// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimStatusTypeDto
 */
export interface IClaimStatusTypeDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimStatusTypeDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimStatusTypeDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimStatusTypeDto
     */
    description?: string;
}

/**
 * Check if a given object implements the IClaimStatusTypeDto interface.
 */
export function instanceOfIClaimStatusTypeDto(value: object): value is IClaimStatusTypeDto {
    return true;
}

export function IClaimStatusTypeDtoFromJSON(json: any): IClaimStatusTypeDto {
    return IClaimStatusTypeDtoFromJSONTyped(json, false);
}

export function IClaimStatusTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimStatusTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function IClaimStatusTypeDtoToJSON(json: any): IClaimStatusTypeDto {
    return IClaimStatusTypeDtoToJSONTyped(json, false);
}

export function IClaimStatusTypeDtoToJSONTyped(value?: IClaimStatusTypeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

